import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, loginUser, logoutUser } from '../../actions/userAction';
import { useSnackbar } from 'notistack';
import BackdropLoader from '../Layouts/BackdropLoader';
import MetaData from '../Layouts/MetaData';
import logo from '../../assets/images/logo-1313mart.png';

const AdminLogin = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const { loading, isAuthenticated, user, error } = useSelector((state) => state.user);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [checkedRole, setCheckedRole] = useState(false);

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(loginUser(email, password));
    };

    useEffect(() => {
        if (error) {
            enqueueSnackbar(error, { variant: "error" });
            dispatch(clearErrors());
        }
    }, [error, dispatch, enqueueSnackbar]);

    // After a successful login, only admin/staff accounts are allowed
    // through to the dashboard — anyone else gets logged straight back
    // out with an explanation, rather than silently sitting on this page.
    useEffect(() => {
        if (!isAuthenticated || !user || checkedRole) return;

        if (user.role === "admin" || user.role === "staff") {
            navigate("/admin/dashboard");
        } else {
            enqueueSnackbar("This account doesn't have admin panel access", { variant: "error" });
            dispatch(logoutUser());
        }
        setCheckedRole(true);
    }, [isAuthenticated, user, checkedRole, navigate, dispatch, enqueueSnackbar]);

    return (
        <>
            <MetaData title="Admin Login | 1313 Mart" />
            {loading && <BackdropLoader />}

            <main className="w-full min-h-screen flex items-center justify-center bg-gray-100 px-4">
                <div className="bg-white shadow-lg rounded-lg w-full max-w-sm p-8 flex flex-col items-center gap-6">
                    <img draggable="false" src={logo} alt="1313 Mart" className="w-20" />
                    <div className="text-center">
                        <h1 className="text-xl font-medium text-gray-800">Admin Panel Login</h1>
                        <p className="text-sm text-gray-400 mt-1">Restricted to authorized staff only</p>
                    </div>

                    <form onSubmit={handleLogin} className="w-full flex flex-col gap-4">
                        <TextField
                            label="Email"
                            type="email"
                            fullWidth
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <TextField
                            label="Password"
                            type={showPassword ? "text" : "password"}
                            fullWidth
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <button type="submit" className="bg-primary-blue text-white py-3 rounded font-medium shadow hover:shadow-lg">
                            Login
                        </button>
                    </form>
                </div>
            </main>
        </>
    );
};

export default AdminLogin;